import { Col, Form, Row} from 'react-bootstrap';
import { AnswerTypeEnum, SurveyQuestionDto } from '../types';
import { getLocalizedText } from '../../../utils/TranslateDescriptionHelper';
import { useTranslation } from 'react-i18next';

interface SurveyQuestionProp {
    question: SurveyQuestionDto;
    questionIndex: number;
    onChangeQuestionValue: (value: string) => void;
    onChangeQuestionOption: (optionId: string) => void;
    errorMessage?: string;
}

export default function SurveyQuestionForm({question, questionIndex, onChangeQuestionValue, onChangeQuestionOption, errorMessage}: SurveyQuestionProp) {
    const { t } = useTranslation(['survey']);    
    const selectedOptionIds = (question?.response ?? "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);
    const hasError = Boolean(errorMessage);

    return (
        <Form.Group>
            <Form.Label className="survey-question-label"><b>{questionIndex != 0 ? `${questionIndex}.` : ""} {getLocalizedText(question.text)}</b></Form.Label>
            {(question.answerType === AnswerTypeEnum.Text) && (
                <>
                    <Form.Control
                        className="mt-1 mb-0"
                        isInvalid={hasError}
                        value={question?.response}
                        onChange={(e) => onChangeQuestionValue(e.target.value)}
                    />
                </>
            )}
            {(question.answerType === AnswerTypeEnum.NPS || question.answerType === AnswerTypeEnum.Number) && (
                <>
                    <Form.Control
                        type="number"
                        className="mt-1 mb-0"
                        isInvalid={hasError}
                        value={question?.response}
                        onChange={(e) => onChangeQuestionValue(e.target.value)}
                    />
                </>
            )}
            {(question.answerType === AnswerTypeEnum.Formula) && (
                <>
                    <Form.Control
                        className="mt-1 mb-0"
                        value={question?.response}
                        disabled
                    />
                </>
            )}
            {question.answerType === AnswerTypeEnum.Option && (
                <div className="mt-1 mb-0">
                    {question.answerOptions?.map((opt, index) => (
                        <Form.Check
                            key={index}
                            type={question.isMultiselector ? "checkbox" : "radio"}
                            label={opt.text?.catalan}
                            className="mb-2"
                            isInvalid={hasError}
                            checked={selectedOptionIds.includes(opt.id)}
                            onChange={() => onChangeQuestionOption(opt.id)}
                        />
                    ))}
                </div>
            )}
            <Row>
                <Col md={6}>
                    <div className="text-muted text-start" style={{ fontSize: "0.85rem" }}>
                        {question.answerType === AnswerTypeEnum.Text && question.maximumNumberOfCharacters && question.maximumNumberOfCharacters != 0 && (
                            <span>{t("survey:maximumNumberOfCharacters", { max: question.maximumNumberOfCharacters })}</span>
                        )}
                        {(question.answerType === AnswerTypeEnum.NPS || question.answerType === AnswerTypeEnum.Number) && 
                        <>
                            {question.minimumValue != null && question.minimumValue > 0 && (
                                <span>{t("survey:scoreText", { value: question.minimumValue })}</span>
                            )}                    
                            {question.maximumValue != null && question.maximumValue > 0 && (
                                <span> {t("survey:toText", { value: question.maximumValue })}</span>
                            )}
                        </>}
                    </div>
                </Col>
                <Col md={6}>
                    {hasError && (
                        <Form.Control.Feedback type="invalid" className="d-block text-end mt-0">
                            {errorMessage}
                        </Form.Control.Feedback>
                    )}
                </Col>
            </Row>
        </Form.Group>
    );
}
